import { RootState } from 'store';

const selectContragentsDate = (state: RootState): Date => state.contragent.data.date;
export default selectContragentsDate;
